// @ts-nocheck
import { FC } from 'react';
import getFormItem from '../hooks/getFormItem';
import { EditVirtualTableCellProps } from '../interface';

/** 单元格 */
const EditVirtualTableCell: FC<EditVirtualTableCellProps> = props => {
  const {
    record,
    editable,
    disabled,
    formItemProps,
    children,
    form,
    dataIndex,
    mergeRowKey,
    columnIndex,
    rowIndex,
    rowRender,
    ...restProps
  } = props;
  if (record?.isMainTable && mergeRowKey) {
    if (columnIndex === 0 && Array.isArray(children))
      return [children[0], rowRender ? rowRender(record) : record[mergeRowKey]];
    return null;
  }
  return (
    <td {...restProps}>
      {editable
        ? getFormItem(record, {
            ...formItemProps,
            disabled,
            form,
            name: Array.isArray(dataIndex)
              ? dataIndex.map(v => `${v}-${record.key}`)
              : `${dataIndex}-${record.key}`,
            // name: `${Array.isArray(dataIndex) ? dataIndex.map(v => `${v}-${record.key}`) : dataIndex}-${record.key}`,
          }, rowIndex)
        : children}
    </td>
  );
};

export default EditVirtualTableCell;
